module.exports = window.React;
